// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.closeFormDialogBackground {
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.7;
    background-color: #000000;
    width: 100vw;
    height: 100vh;
    z-index: 1;
}

.closeFormDialogBox {
    position: fixed;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    border-radius: 1.25rem;
    padding: 7.5px;
    width: 350px;
    max-width: 85vw;
}

.closeFormDialog_cancel {
    width: 1rem;
    height: 1rem;
    object-fit: contain;
    align-self: flex-end;
    cursor: pointer;
}

.closeFormDialog_icn {
    width: 5.5rem;
    height: 5.5rem;
    object-fit: contain;
    align-self: center;
}


.closeFormDialog_mssg{
    align-self: center;
    text-align: center;
    font-weight: 700;
    font-size: 1.15rem;
    line-height: 2rem;
    padding: 0 7.5%;
}

.closeFormDialog_action {
    display: flex;
    justify-content: space-around;
    padding: 0 2.5%;
}

.closeFormDialog_action_btn {
    text-align: center;
    background: transparent;
    padding: .8rem 2rem;
    cursor: pointer;
    border-radius: 1.15rem;
}

.close_form_btn_left {
    border: 1px solid #FF4425;
    color: #FF4425;
}

.close_form_btn_right {
    background: #00127E;
    color: white;
}

@media screen and (max-height: 350px) {
    .closeFormDialog_icn{
        display: none;
    }
    .closeFormDialog_mssg, .closeFormDialog_action {
        padding: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/fields/closeFormDialog/styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,UAAU;AACd;;AAEA;IACI,eAAe;IACf,UAAU;IACV,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".closeFormDialogBackground {\n    position: fixed;\n    top: 0;\n    left: 0;\n    opacity: 0.7;\n    background-color: #000000;\n    width: 100vw;\n    height: 100vh;\n    z-index: 1;\n}\n\n.closeFormDialogBox {\n    position: fixed;\n    z-index: 1;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    flex-direction: column;\n    background: #FFFFFF;\n    border-radius: 1.25rem;\n    padding: 7.5px;\n    width: 350px;\n    max-width: 85vw;\n}\n\n.closeFormDialog_cancel {\n    width: 1rem;\n    height: 1rem;\n    object-fit: contain;\n    align-self: flex-end;\n    cursor: pointer;\n}\n\n.closeFormDialog_icn {\n    width: 5.5rem;\n    height: 5.5rem;\n    object-fit: contain;\n    align-self: center;\n}\n\n\n.closeFormDialog_mssg{\n    align-self: center;\n    text-align: center;\n    font-weight: 700;\n    font-size: 1.15rem;\n    line-height: 2rem;\n    padding: 0 7.5%;\n}\n\n.closeFormDialog_action {\n    display: flex;\n    justify-content: space-around;\n    padding: 0 2.5%;\n}\n\n.closeFormDialog_action_btn {\n    text-align: center;\n    background: transparent;\n    padding: .8rem 2rem;\n    cursor: pointer;\n    border-radius: 1.15rem;\n}\n\n.close_form_btn_left {\n    border: 1px solid #FF4425;\n    color: #FF4425;\n}\n\n.close_form_btn_right {\n    background: #00127E;\n    color: white;\n}\n\n@media screen and (max-height: 350px) {\n    .closeFormDialog_icn{\n        display: none;\n    }\n    .closeFormDialog_mssg, .closeFormDialog_action {\n        padding: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
